import { ColumnMetadata, DataGrid, RowSizes } from "~/components/DataGrid";
import { ApiQuery, PaginationState } from "~/modules/filters/types";
import { AssetTableRowData } from "./types";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { AssetTableRow } from "./AssetTableRow";
import { ASSET_SORT_MAP } from "./useInMemoryAssetSort";
import { sortItemsByProperty } from "~/utils/functions/sortItemsByProperty";

// // // //

export function AssetTable(props: {
    query: ApiQuery;
    loading?: boolean;
    columns: ColumnMetadata<AssetTableRowData, AssetColumns>[];
    rows: Asset[];
    paginationState?: PaginationState;
    onChangeQuery?: (updatedQuery: ApiQuery) => void;
    bordered?: boolean;
    size?: RowSizes;
    fixedHeader?: boolean;
    fixedHeaderClassName?: string;
    enableItemsPerPageSelect?: boolean;
    enablePagerPagination?: boolean;
    enableScrollButton?: boolean;
    enableScrollbar?: boolean;
    disablePagination?: boolean;
    analyticsTableName: string;
    flush?: boolean;
    showHeader?: boolean;
    includeDummyRows?: boolean;
    watermark?: boolean;
    striped?: boolean;
    defaultExpandedState?: boolean;
    includeAdditionalNetworksRow?: boolean;
}) {
    const {
        columns,
        rows,
        size = RowSizes.small,
        paginationState,
        analyticsTableName,
        defaultExpandedState = false,
        enableScrollButton,
        flush,
        bordered = true,
        striped = true,
        fixedHeader = true,
        showHeader = true,
        enableItemsPerPageSelect = false,
        enablePagerPagination,
        enableScrollbar,
        disablePagination,
        includeDummyRows,
        watermark,
        fixedHeaderClassName,
        query,
        loading = false,
        onChangeQuery,
        includeAdditionalNetworksRow = true,
    } = props;

    return (
        <DataGrid
            query={query}
            columns={columns}
            rows={rows}
            rowKey="id"
            bordered={bordered}
            size={size}
            loading={loading}
            fixedHeader={fixedHeader}
            fixedHeaderClassName={fixedHeaderClassName}
            analyticsTableName={analyticsTableName}
            paginationState={paginationState}
            onChangeQuery={onChangeQuery}
            enableItemsPerPageSelect={enableItemsPerPageSelect}
            enablePagerPagination={enablePagerPagination}
            enableScrollButton={enableScrollButton}
            enableScrollbar={enableScrollbar}
            disablePagination={disablePagination}
            includeDummyRows={includeDummyRows}
            watermark={watermark}
            flush={flush}
            showHeader={showHeader}
        >
            {({ row, rowIndex, scrollLeft }) => (
                <AssetTableRow
                    asset={{
                        ...row,
                        // NOTE - this is a hack to sort the tokens by the same sort field as the assets
                        tokens: sortItemsByProperty({
                            items: row.tokens,
                            field: ASSET_SORT_MAP[
                                query.sort.field as AssetColumns
                            ],
                            direction: query.sort.direction,
                            nullsLast: true,
                        }),
                    }}
                    size={size}
                    columns={
                        columns as ColumnMetadata<
                            AssetTableRowData,
                            AssetColumns
                        >[]
                    }
                    rowIndex={rowIndex}
                    scrollLeft={scrollLeft}
                    bordered={bordered}
                    defaultExpandedState={defaultExpandedState}
                    striped={striped}
                    includeAdditionalNetworksRow={includeAdditionalNetworksRow}
                />
            )}
        </DataGrid>
    );
}
